import { memo, useMemo } from 'react'
import { Table, Space, Popconfirm } from 'antd'
import type { ColumnsType } from 'antd/es/table'
import { LeagueFormat } from 'types/league-formats'
import { modalTitle as formatModalTitle } from 'utils/modal-title'

type Props = {
    data: LeagueFormat[]
    onEdit: (id: number) => void
    onDelete: (id: number) => void
    loading: boolean
}

export const LeagueFormatsTable = memo((props: Props) => {
    const { data, onEdit, onDelete, loading } = props

    const columns: ColumnsType<LeagueFormat> = useMemo(
        () => [
            {
                title: 'ID',
                dataIndex: 'id',
                key: 'id',
            },
            {
                title: 'Name',
                dataIndex: 'name',
                key: 'name',
            },
            {
                title: 'Action',
                key: 'action',
                render: (_, record) => (
                    <Space size='middle'>
                        <a onClick={() => onEdit(record.id)}>Edit</a>
                        <Popconfirm
                            title={formatModalTitle('Delete league format', record.name)}
                            description={'Are you sure to delete this league format?'}
                            onConfirm={() => onDelete(record.id)}
                            okText={'Yes'}
                            cancelText={'No'}
                        >
                            <a href='#'>Delete</a>
                        </Popconfirm>
                    </Space>
                ),
            },
        ],
        [onDelete, onEdit]
    )

    return <Table loading={loading} columns={columns} dataSource={data} rowKey='id' pagination={false} />
})
